import { createReducer } from '@reduxjs/toolkit';
import * as actions from './actions';
const initialState = {
    profilingAgreement: false,
    marketingAgreement: false,
    marketingChannelEmail: false,
    marketingChannelPhone: false,
    marketingChannelPaperMail: false,
    marketingPushNotification: false,
    hasOptinSurvey: false,
    hasError: false,
    isTouched: false,
};
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(actions.setIsPrivacyConsent, (state, { payload }) => {
        const newState = {
            ...state,
            [payload || '']: payload && !state[payload],
        };
        if (!newState.marketingAgreement) {
            return {
                ...newState,
                ...{
                    marketingChannelEmail: false,
                    marketingChannelPhone: false,
                    marketingChannelPaperMail: false,
                    hasError: false,
                },
            };
        }
        const errorState = newState.marketingAgreement &&
            (newState.marketingChannelEmail ||
                newState.marketingChannelPhone ||
                newState.marketingChannelPaperMail ||
                newState.marketingPushNotification)
            ? {
                hasError: false,
            }
            : {
                hasError: true,
            };
        return {
            ...newState,
            ...errorState,
        };
    })
        .addCase(actions.setIsPrivacyConsentTouched, (state) => ({
        ...state,
        isTouched: true,
    }))
        .addCase(actions.initialPrivacyConsent, (state) => ({
        ...state,
        ...initialState,
    }));
});
